import {
  SEARCH_PRODUCT_REQUESTED,
  SEARCH_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_FAILURE,
  FIND_PRODUCT_INVENTORIES_REQUESTED,
  FIND_PRODUCT_INVENTORIES_SUCCESS,
  FIND_PRODUCT_INVENTORIES_FAILURE,
  DELETE_PRODUCT_METAFIELD_REQUESTED,
  DELETE_PRODUCT_METAFIELD_SUCCESS,
  UPDATE_SELECTED_ITEMS,
  SCAN_PRODUCT_REQUESTED,
  SCAN_PRODUCT_SUCCESS,
  SCAN_PRODUCT_FAILURE,
  ASSIGNMENTS_UPDATE_SUCCESS,
  RESET_PRODUCTS_STATE,
  ASSIGNMENT_CREATE_REQUESTED,
  ASSIGNMENT_CREATE_SUCCESS,
  ASSIGNMENTS_DELETE_REQUESTED,
  ASSIGNMENTS_DELETE_SUCCESS,
} from '../types';

const INITIAL_STATE = {
  activeProductInventoryDetails: null,
  searchedBrands: {},
  searchedProducts: null,
  searchedProductsPagination: null,
  searchedProductsMetafields: {},
  searchedVariants: null,
  searchedVariantsMetafields: {},
  isFetching: false,
  status: 'waiting',
  selectedProductList: { variants: {}, products: {} },
  errors: null,
  scanBackgroundColor: "primary20",
  scanMessage: "Scan barcodes to add items to this PO"
};

const products = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case SEARCH_PRODUCT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        searchedBrands: {},
        searchedProducts: null,
        searchedProductsPagination: null,
        searchedVariants: null,
      });

    case SEARCH_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        searchedBrands: action.payload.brands,
        searchedProducts: action.payload.products,
        searchedProductsPagination: action.payload.product_pagination,
        searchedProductsMetafields: action.payload.product_metafields,
        searchedVariants: action.payload.variants,
        searchedVariantsMetafields: action.payload.variant_metafields || {},
        isFetching: false,
        status: 'success',
        errors: null
      });

    case SEARCH_PRODUCT_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case ASSIGNMENTS_UPDATE_SUCCESS:
      let body = {supplier_sku: action.response.supplier_sku, minimum_order: action.response.minimum_order, supplier_price: action.response.supplier_price, order_multiple: action.response.order_multiple, pack_quantity: action.response.pack_quantity}
      let supplierKey = `Supplier-${action.response.supplier_id}`;

      if(action.response.variant_id) {
        if(newState.searchedVariantsMetafields && newState.searchedVariantsMetafields[action.assignmentId]) {
          let target = newState.searchedVariantsMetafields[action.assignmentId].data.find(metafield => metafield.key = supplierKey);
          target.value = JSON.stringify(body);
        }
      } else {
        if(newState.searchedProductsMetafields && newState.searchedProductsMetafields[action.response.product_id]) {
          let target = newState.searchedProductsMetafields[action.response.product_id].data.find(metafield => metafield.key = supplierKey);
          target.value = JSON.stringify(body);
        }
      }
      return newState;

    case UPDATE_SELECTED_ITEMS:
      return Object.assign({}, state, {
        selectedProductList: action.payload
      });

    case SCAN_PRODUCT_REQUESTED:
      return Object.assign({}, state, {
        scanBackgroundColor: "primary10",
        scanMessage: "Searching for barcode..."
      });

    case SCAN_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        scanBackgroundColor: "success20",
        scanMessage: "Barcode found"
      });

    case SCAN_PRODUCT_FAILURE:
      return Object.assign({}, state, {
        scanBackgroundColor: "danger20",
        scanMessage: (action.message || "Failed to load item")
      });

      // TODO: this should be done in the delete success, not in the request, but duplicating isn't happening correctly
    case ASSIGNMENTS_DELETE_REQUESTED:
      if(action.variantId) {
        newState.searchedVariantsMetafields[`${action.productId}/${action.variantId}`] = { data: [] }
      } else {
        newState.searchedProductsMetafields[action.productId] = { data: [] }
      }
      
      return newState;

    case ASSIGNMENTS_DELETE_SUCCESS:
      let toDelete = null;
      if(action.response['data'].variant_id) {
        newState.searchedVariantsMetafields[`${action.response['data'].product_id}/${action.response['data'].variant_id}`] = { data: [] }
      } else {
        newState.searchedProductsMetafields[action.response['data'].product_id] = { data: [] }
      }

      return newState;

    case ASSIGNMENT_CREATE_REQUESTED:
    case ASSIGNMENT_CREATE_SUCCESS:
      // This could probably be better, not really duplicating correctly so no updates on success, but should be only on success, shouldn't eliminate so much stuff
      if(action.payload.assignmentValues.type === 'variant') {
        newState.searchedVariantsMetafields[`${action.payload.assignmentValues.productId}/${action.payload.assignmentValues.variantId}`] = {
          data: [{
            namespace: "Supplier Purchase Orders - Supplier",
            key: `Supplier-${action.payload.supplierId}`,
            value: JSON.stringify({
              supplier_price: action.payload.assignmentValues.supplierPrice,
              supplier_sku: action.payload.assignmentValues.supplierSku,
              minimum_order: action.payload.assignmentValues.minimumQuantity,
              order_multiple: action.payload.assignmentValues.orderMultiple,
              pack_quantity: action.payload.assignmentValues.packQuantity,
            })
          }]
        }
      }

      if(action.payload.assignmentValues.type === 'product') {
        newState.searchedProductsMetafields[`${action.payload.assignmentValues.productId}`] = {
          data: [{
            namespace: "Supplier Purchase Orders - Supplier",
            key: `Supplier-${action.payload.supplierId}`,
            value: JSON.stringify({
              supplier_price: action.payload.assignmentValues.supplierPrice,
              supplier_sku: action.payload.assignmentValues.supplierSku,
              minimum_order: action.payload.assignmentValues.minimumQuantity,
              order_multiple: action.payload.assignmentValues.orderMultiple,
              pack_quantity: action.payload.assignmentValues.packQuantity,
            })
          }]
        }
      }

      return newState;

    case FIND_PRODUCT_INVENTORIES_REQUESTED:
      newState.activeProductInventoryDetails = null;
      return newState;

    case FIND_PRODUCT_INVENTORIES_SUCCESS:
      newState.activeProductInventoryDetails = action.payload;
      return newState;

    case RESET_PRODUCTS_STATE:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default products;
